import { KEY_STORE } from '@/constants/enum'
/**
 * Get parameter on url
 *
 * @param {key} String
 * @return {String}
 */
export const getParameterItem = key => {
  const urlParams = new URLSearchParams(window.location.search)

  return urlParams.get(key)
}

export const setLocalStorage = (data, key = '') => {
  return window.localStorage.setItem(key || KEY_STORE, data)
}

export const getLocalStorage = (key = '') => {
  return window.localStorage.getItem(key || KEY_STORE)
}

export const clearLocalStorage = () => {
  return window.localStorage.removeItem(KEY_STORE)
}

export const uniqueId = str => {
  const crypto = window.crypto || window.msCrypto
  const array = new Uint32Array(1)
  crypto.getRandomValues(array)
  return `${str}${Math.floor(crypto.getRandomValues(array))}`
}

export const roundedImage = (ctx, x, y, width, height, radius = 10) => {
  ctx.beginPath()
  ctx.moveTo(x + radius, y)
  ctx.lineTo(x + width - radius, y)
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius)
  ctx.lineTo(x + width, y + height - radius)
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height)
  ctx.lineTo(x + radius, y + height)
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius)
  ctx.lineTo(x, y + radius)
  ctx.quadraticCurveTo(x, y, x + radius, y)
  ctx.closePath()
}

export const roundedImageCirle = (cWidth, cHeight, src) => {
  let canvas = document.createElement('canvas')
  canvas.width = cWidth
  canvas.height = cHeight
  let ctx = canvas.getContext('2d')
  const sizeCirle = cWidth / 2 - 2
  const x = cWidth / 2
  const y = cHeight / 2 + 0.5
  const img = new Image()

  img.src = src
  return new Promise(resolve => {
    img.onload = () => {
      ctx.save()
      ctx.beginPath()
      ctx.arc(x, y, sizeCirle, 0, Math.PI * 2, false)
      ctx.clip()
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, img.width, img.height)
      ctx.drawImage(img, 0, 0, cWidth, cHeight)
      ctx.restore()
      resolve(canvas.toDataURL('image/png'))
    }
  })
}

export const fillStyleBackgroundImage = (cWidth, cHeight, src) => {
  let canvas = document.createElement('canvas')
  canvas.width = cWidth
  canvas.height = cHeight
  let ctx = canvas.getContext('2d')
  const img = new Image()

  img.src = src
  return new Promise(resolve => {
    img.onload = () => {
      ctx.strokeStyle = '#2465D3'
      ctx.lineWidth = 2
      ctx.stroke()
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, img.width, img.height)
      ctx.drawImage(img, 0, 0, cWidth, cHeight)
      ctx.restore()
      resolve(canvas.toDataURL('image/png'))
    }
  })
}
